'use client';
import React from 'react';
import { CheckCircle, ChevronLeft, ChevronRight } from 'lucide-react';

const SaishirtoursSection = () => {
  const carouselImages = [
    "https://book.saishishirtours.in/wp-content/uploads/2025/06/WhatsApp-Image-2025-08-01-at-12.11.39-PM-1024x682.jpeg",
    "https://book.saishishirtours.in/wp-content/uploads/2025/06/WhatsApp-Image-2025-08-01-at-12.11.38-PM-1-1024x746.jpeg",
    "https://book.saishishirtours.in/wp-content/uploads/2025/06/WhatsApp-Image-2025-08-01-at-12.11.37-PM-1-1024x682.jpeg",
    "https://book.saishishirtours.in/wp-content/uploads/2025/06/WhatsApp-Image-2025-08-01-at-12.11.38-PM-1024x682.jpeg"
  ];

  const features = [
    "Award-Winning Excellence",
    "Decade of Dedication",
    "Expert Leadership",
    "Seamless Journeys",
    "Global Reach"
  ];

  return (
    <section className="py-5" >
      <div className="container">
        <div className="row align-items-center g-4">

          {/* Carousel Column */}
          <div className="col-lg-6">
            <div className="position-relative saishirtours-carousel">
              <div id="saishirtoursCarousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner rounded-3 overflow-hidden">
                  {carouselImages.map((image, index) => (
                    <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                      <img
                        src={image}
                        className="d-block w-100"
                        alt={`Saishirtours ${index + 1}`}
                      />
                    </div>
                  ))}
                </div>

                {/* Previous Button */}
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#saishirtoursCarousel"
                  data-bs-slide="prev"
                >
                  <div className="rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px',backgroundColor:'#ffffff47' }}>
                    <ChevronLeft size={20} className="text-dark" />
                  </div>
                  <span className="visually-hidden">Previous</span>
                </button>

                {/* Next Button */}
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#saishirtoursCarousel"
                  data-bs-slide="next"
                >
                  <div className=" rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center" style={{ width: '30px', height: '30px',backgroundColor:'#ffffff47' }}>
                    <ChevronRight size={20} className="text-dark" />
                  </div>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
          </div>

          {/* Features Column */}
          <div className="col-lg-6">
            <div className="ps-lg-5">
             <h2 className="fw-bold mb-4" style={{ color: '#0b4878' }}>Fascinating Facts About<br></br> Saishirtours!</h2>
              {features.map((feature, index) => (
                <div key={index} className="d-flex align-items-center mb-3">
                  <div className="me-3">
                    <div className="d-flex align-items-start rounded-3 ">
                                      <CheckCircle className="me-3 mt-1" color="#22c55e" size={24} />
                                    
                                    </div>
                  </div>
                  <span className="text-dark fw-medium">{feature}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* Inline CSS for responsive carousel with aspect ratio */}
      <style jsx>{`
        .saishirtours-carousel {
          position: relative;
          width: 100%;
        }
        .saishirtours-carousel .carousel-inner {
          width: 100%;
          /* Maintain aspect ratio ~ 1024x682 */
          padding-top: 66.6%; 
          position: relative;
        }
        .saishirtours-carousel .carousel-item {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .saishirtours-carousel img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `}</style>
    </section>
  );
};

export default SaishirtoursSection;
